import type { CoreUser } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Restore user logged account.
 *
 * @endpoint POST /api/me/restore
 * @scope shared
 * @see https://flecto.dev/api-4724195
 */
export async function restoreUser(): Promise<CoreUser> {
  const response = await api.post('/api/me/restore')
  const { data } = deserialize<CoreUser>(response.data)

  return data
}
